import * as Yup from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const REQUIRED_ERROR_MESSAGE = 'Ce champ est obligatoire';

const defaultValidators = {
  number: Yup.number().typeError('Ce champ doit être un numéro').required(REQUIRED_ERROR_MESSAGE),
  date: Yup.date().typeError('Ce champ doit être une date valide').required(REQUIRED_ERROR_MESSAGE),
  text: Yup.string().required(REQUIRED_ERROR_MESSAGE),
  textOpt: Yup.string().optional(),
  radioGroup: Yup.mixed().required(REQUIRED_ERROR_MESSAGE),
  tel: Yup.string()
    .test('phone', 'Numéro de téléphone invalide', (value) => {
      if (!value) return true;
      try {
        const number = phoneUtil.parseAndKeepRawInput(value, 'FR');
        return phoneUtil.isValidNumber(number);
      } catch {
        return false;
      }
    })
    .required(REQUIRED_ERROR_MESSAGE),
  textarea: Yup.string().required(REQUIRED_ERROR_MESSAGE),
  email: Yup.string().email('Email invalide').required(REQUIRED_ERROR_MESSAGE),
  name: Yup.string()
    .min(2, 'Le nom doit contenir au moins 2 caractères')
    .required(REQUIRED_ERROR_MESSAGE),
  rpps: Yup.string()
    .required(REQUIRED_ERROR_MESSAGE)
    .matches(/^1[0-9]{10}$/, 'Le numéro RPPS doit contenir 11 chiffres et commencer par 1'),
  password: Yup.string()
    .trim()
    .min(8, 'Trop court')
    .matches(/[A-Z]/, {
      name: 'uppercase',
      message: 'Doit contenir au moins une majuscule',
    })
    .matches(/\d/, {
      name: 'digit',
      message: 'Doit contenir au moins un chiffre',
    })
    .required(REQUIRED_ERROR_MESSAGE),
  confirm_password: Yup.string()
    .trim()
    .oneOf([Yup.ref('password')], 'Les mots de passe ne correspondent pas')
    .required(REQUIRED_ERROR_MESSAGE),
  password_login: Yup.string()
    .trim()
    .min(8, 'Trop court')
    .matches(/[A-Z]/, {
      name: 'uppercase',
      message: 'Doit contenir au moins une majuscule',
    })
    .matches(/\d/, {
      name: 'digit',
      message: 'Doit contenir au moins un chiffre',
    })
    .required(REQUIRED_ERROR_MESSAGE),
  checkbox: Yup.boolean(),
  checkboxGroup: Yup.array()
    .of(Yup.string())
    .ensure()
    .min(1, 'Veuillez sélectionner au moins une valeur'),
  checked: Yup.boolean().isTrue(REQUIRED_ERROR_MESSAGE),
  autocomplete: Yup.object({
    streetNumber: Yup.string()
      .required("Le numéro de rue est obligatoire pour valider l'adresse.")
      .test(
        'valid-street-number',
        'Le numéro de rue sélectionné est invalide. Veuillez choisir une adresse complète dans la liste.',
        (v) => !!v && v !== 'null' && v.trim() !== '',
      ),

    route: Yup.string()
      .required("Le nom de la rue est obligatoire pour valider l'adresse.")
      .test(
        'valid-route',
        'Le nom de la rue est invalide. Veuillez sélectionner une adresse proposée.',
        (v) => !!v && v !== 'null' && v.trim() !== '',
      ),

    postalCode: Yup.string()
      .required("Le code postal est obligatoire pour valider l'adresse.")
      .test(
        'valid-postal-code',
        'Le code postal est invalide. Merci de sélectionner une adresse complète.',
        (v) => !!v && v !== 'null' && v.trim() !== '',
      ),
  }).required('Veuillez renseigner une adresse complète.'),
  address_complement: Yup.string().optional(),

  siren: Yup.string()
    .min(9, 'Le SIREN doit contenir 9 caractères')
    .max(9, 'Le SIREN doit contenir 9 caractères'),
  iban: Yup.string()
    .min(27, "L'IBAN doit contenir 27 caractères")
    .max(27, "L'IBAN doit contenir 27 caractères")
    .required(REQUIRED_ERROR_MESSAGE),
};

export default defaultValidators;
